import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-300d4c4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "swiper-wrapper"
};
const _hoisted_2 = {
  class: "image-wrapper"
};
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = {
  key: 1,
  class: "plugin_list"
};
const _hoisted_5 = {
  key: 2,
  class: "plugin_list"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "plugin-item skeleton-item"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "plugin-item skeleton-item"
}, null, -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  const _component_PluginItem = _resolveComponent("PluginItem");
  const _component_PluginGuide = _resolveComponent("PluginGuide");
  const _component_Spin = _resolveComponent("Spin");
  const _component_Fail = _resolveComponent("Fail");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["plugin_wrapper", {
      'is-vip': _ctx.isVip,
      'top': !_ctx.status
    }]),
    onTouchmove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [_ctx.status ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_swiper, {
    ref: "mySwiper",
    class: "swiper",
    autoplay: {
      delay: 5000
    },
    loop: "",
    modules: _ctx.modules,
    pagination: {
      clickable: true
    },
    "virtual-index": 99,
    onSwiper: _ctx.onSwiper,
    onSlideChange: _ctx.onSlideChange
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bannerData, (item, index) => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: index
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
          class: "image",
          src: item.preview,
          draggable: "false",
          onClick: $event => _ctx.goToDoc(item)
        }, null, 8, _hoisted_3)])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "onSwiper", "onSlideChange"])])) : _createCommentVNode("", true), _ctx.pluginData.length > 0 && _ctx.status ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pluginData, (item, index) => {
    return _openBlock(), _createBlock(_component_PluginItem, {
      key: item.id,
      plugin: item,
      index: index,
      onHandlePluginClick: _ctx.handlePluginClick,
      onPollPlugin: _ctx.pollPlugin,
      onClearAppTimer: _ctx.clearAppTimer
    }, null, 8, ["plugin", "index", "onHandlePluginClick", "onPollPlugin", "onClearAppTimer"]);
  }), 128)), _createVNode(_component_PluginGuide, {
    plugin: _ctx.pluginData[0]
  }, null, 8, ["plugin"])])) : _createCommentVNode("", true), _ctx.pluginData.length === 0 && _ctx.status ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8)) : _createCommentVNode("", true), _ctx.isLoading ? (_openBlock(), _createBlock(_component_Spin, {
    key: 3
  })) : _createCommentVNode("", true), !_ctx.status ? (_openBlock(), _createBlock(_component_Fail, {
    key: 4
  })) : _createCommentVNode("", true)], 34);
}